/* eslint-disable  */
import React from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
  Box,
  IconButton,
  Link,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  mobileDialog: {
    backdropFilter: "blur(8px)",
  },
  mobilePaper: {
    margin: theme.spacing(2),
    borderRadius: 16,
    boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.3)",
    maxHeight: "calc(100% - 64px)",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "rgba(255, 255, 255, 0.97)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
  },
  desktopPaper: {
    borderRadius: 12,
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    borderRadius: "16px 16px 0 0",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2.5),
      position: "sticky",
      top: 0,
      zIndex: 1,
    },
  },
  closeButton: {
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(1),
    marginRight: theme.spacing(-1),
    touchAction: "manipulation",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0.5),
    },
  },
  closeIcon: {
    fontSize: 24,
    [theme.breakpoints.down("sm")]: {
      fontSize: 20,
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2.5),
      flex: 1,
    },
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 0),
    },
  },
  listBullet: {
    minWidth: 28,
    marginRight: theme.spacing(2),
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontSize: "1.1rem",
    [theme.breakpoints.down("sm")]: {
      minWidth: 24,
      marginRight: theme.spacing(1.5),
    },
  },
  link: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    textDecoration: "none",
    display: "inline-block",
    marginTop: 4,
    "&:hover": {
      textDecoration: "underline",
      opacity: 0.9,
    },
  },
  highlight: {
    backgroundColor: theme.palette.warning.light,
    padding: theme.spacing(0.5, 1),
    borderRadius: 6,
    fontWeight: 700,
    color: theme.palette.warning.dark,
  },
  noteSection: {
    backgroundColor: "rgba(33, 150, 243, 0.05)",
    padding: theme.spacing(2.5),
    borderRadius: 12,
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.primary.light}`,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(1.5),
    },
  },
  noteIcon: {
    marginRight: theme.spacing(1.5),
    color: theme.palette.warning.main,
    fontSize: "1.2rem",
  },
  buttonContainer: {
    [theme.breakpoints.down("sm")]: {
      position: "sticky",
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      marginTop: "auto",
    },
  },
  actionButton: {
    borderRadius: 12,
    padding: theme.spacing(1.75),
    fontWeight: 600,
    fontSize: "1rem",
    marginTop: theme.spacing(2),
    textTransform: "none",
    boxShadow: "0px 4px 12px rgba(33, 150, 243, 0.3)",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0px 6px 16px rgba(33, 150, 243, 0.4)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
      borderRadius: 10,
    },
  },
  divider: {
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(1.5, 0),
    },
  },
  stepDivider: {
    margin: theme.spacing(1.5, 0),
    opacity: 0.3,
  },
}));

const LicenseRenewalModal = ({ open, onClose }) => {
  const theme = useTheme();
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      classes={{
        root: fullScreen ? classes.mobileDialog : "",
        paper: fullScreen ? classes.mobilePaper : classes.desktopPaper,
      }}
      BackdropProps={{
        style: {
          backgroundColor: fullScreen
            ? "rgba(0,0,0,0.3)"
            : "rgba(0, 0, 0, 0.5)",
        },
      }}
      PaperProps={{
        style: fullScreen
          ? {
            background: "rgba(255, 255, 255, 0.97)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
          }
          : {},
      }}
      disableEscapeKeyDown={false}
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography
          variant="h6"
          style={{
            fontWeight: 700,
            fontSize: fullScreen ? "1.1rem" : "1.25rem",
          }}
        >
          LICENSE RENEWAL FOR NURSES AND MIDWIVES
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size={fullScreen ? "small" : "medium"}
        >
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className={classes.dialogContent}>
        <Typography
          paragraph
          style={{ fontSize: fullScreen ? "0.95rem" : "1rem" }}
        >
          Below is the official and recommended process for renewing your{" "}
          <strong className={classes.highlight}>PIN/AIN</strong>:
        </Typography>

        <List disablePadding>
          <ListItem className={classes.listItem}>
            <Typography className={classes.listBullet}>1</Typography>
            <ListItemText
              primary="Register on the NMC Portal"
              secondary={
                <Link
                  href="https://nmc.gov.gh/license-renewal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                >
                  https://nmc.gov.gh/license-renewal/
                </Link>
              }
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: fullScreen ? "0.95rem" : "1rem",
              }}
              secondaryTypographyProps={{
                component: "div",
                fontSize: fullScreen ? "0.85rem" : "0.9rem",
              }}
            />
          </ListItem>

          <Divider
            component="li"
            variant="middle"
            className={classes.stepDivider}
          />

          <ListItem className={classes.listItem}>
            <Typography className={classes.listBullet}>2</Typography>
            <ListItemText
              primary="Register with WCEA"
              secondary={
                <Link
                  href="https://engagement.wcea.education/NMCG?source_code=1155100"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                >
                  https://engagement.wcea.education/NMCG
                </Link>
              }
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: fullScreen ? "0.95rem" : "1rem",
              }}
              secondaryTypographyProps={{
                component: "div",
                fontSize: fullScreen ? "0.85rem" : "0.9rem",
              }}
            />
          </ListItem>

          <Divider
            component="li"
            variant="middle"
            className={classes.stepDivider}
          />

          <ListItem className={classes.listItem}>
            <Typography className={classes.listBullet}>3</Typography>
            <ListItemText
              primary="Download the WCEA App (Google Play Store or Apple App Store)"
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: fullScreen ? "0.95rem" : "1rem",
              }}
            />
          </ListItem>

          <Divider
            component="li"
            variant="middle"
            className={classes.stepDivider}
          />

          <ListItem className={classes.listItem}>
            <Typography className={classes.listBullet}>4</Typography>
            <ListItemText
              primary="Complete CPD Courses on the WCEA App to obtain required CPD points"
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: fullScreen ? "0.95rem" : "1rem",
              }}
            />
          </ListItem>

          <Divider
            component="li"
            variant="middle"
            className={classes.stepDivider}
          />

          <ListItem className={classes.listItem}>
            <Typography className={classes.listBullet}>5</Typography>
            <ListItemText
              primary="Upload CPD points on the NMC portal"
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: fullScreen ? "0.95rem" : "1rem",
              }}
            />
          </ListItem>

          <Divider
            component="li"
            variant="middle"
            className={classes.stepDivider}
          />

          {/* <ListItem className={classes.listItem}>
            <Typography className={classes.listBullet}>6</Typography>
            <ListItemText
              primary="Generate invoice and make payment on the NMC portal"
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: fullScreen ? "0.95rem" : "1rem",
              }}
            />
          </ListItem> */}
        </List>

        <Typography
          paragraph
          style={{ marginTop: 20, fontSize: fullScreen ? "0.95rem" : "1rem" }}
        >
          Your <strong>PIN/AIN</strong> will be renewed after successful payment
          and verification.
        </Typography> */}

        <Divider className={classes.divider} />

        <Box className={classes.noteSection}>
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 700,
              marginBottom: 12,
              display: "flex",
              alignItems: "center",
            }}
          >
            <span role="img" aria-label="warning" className={classes.noteIcon}>
              ⚠️
            </span>
            Important Notes:
          </Typography>

          <List disablePadding>
            <ListItem className={classes.listItem}>
              <Typography
                className={classes.listBullet}
                style={{ fontSize: "1.5rem" }}
              >
                •
              </Typography>
              <ListItemText
                primary="License renewal will only be successful after obtaining the required CPD points."
                primaryTypographyProps={{
                  fontSize: fullScreen ? "0.9rem" : "0.95rem",
                }}
              />
            </ListItem>

            <ListItem className={classes.listItem}>
              <Typography
                className={classes.listBullet}
                style={{ fontSize: "1.5rem" }}
              >
                •
              </Typography>
              <ListItemText
                primary="The renewal process is personalized. For security reasons, no one should renew your license on your behalf."
                primaryTypographyProps={{
                  fontSize: fullScreen ? "0.9rem" : "0.95rem",
                }}
              />
            </ListItem>

            <ListItem className={classes.listItem}>
              <Typography
                className={classes.listBullet}
                style={{ fontSize: "1.5rem" }}
              >
                •
              </Typography>
              <ListItemText
                primary="For assistance, contact your District or Regional UPNMG Executives."
                primaryTypographyProps={{
                  fontSize: fullScreen ? "0.9rem" : "0.95rem",
                }}
              />
            </ListItem>
          </List>
        </Box>

        <Box className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            fullWidth
            className={classes.actionButton}
          >
            I Understand
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LicenseRenewalModal;
